
export default {
  props: {
    contactData: {
      type: Object,
      default: () => ({
        email: 'support@properlly.com',
        lineId: '@properlly',
        phoneNumber: '094-197-1410',
      }),
    },
  },
}
